import React from "react";
import { tono } from "./tonos";

const RADIO = 42;
const GROSOR = 14;

/**
 * Dona por categoría del kit de tableros, dibujada en SVG propio (la de
 * codekit no cabe en las columnas del escritorio y su leyenda se salía de
 * la tarjeta). Leyenda en filas: punto del tono, etiqueta, valor y
 * porcentaje; cada segmento y cada fila son un drill-down.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {string} titulo      Kicker de la tarjeta
 * @param {string} subtitulo   Título bajo el kicker
 * @param {Array} segmentos    [{clave, etiqueta, valor, texto, tonoxxx, nota}] (texto = valor formateado para la leyenda)
 * @param {string|number} total Número del centro (default: suma)
 * @param {string} totalEtiqueta Texto bajo el número del centro
 * @param {function} onSegmento Drill-down (recibe el segmento)
 */
const Donaxxxx = ({ titulo, subtitulo, segmentos = [], total, totalEtiqueta, onSegmento }) => {
  const valores = segmentos.map((s) => Math.max(0, Number(s.valor) || 0));
  const suma = valores.reduce((n, v) => n + v, 0);
  const circunferencia = 2 * Math.PI * RADIO;
  let acumulado = 0;
  const arcos = segmentos.map((s, i) => {
    const fraccion = suma > 0 ? valores[i] / suma : 0;
    const largo = fraccion * circunferencia;
    const arco = { s, largo, offset: -acumulado, fraccion };
    acumulado += largo;
    return arco;
  });
  const vacio = suma === 0;

  return (
    <div className="tbl-card">
      <span className="tbl-kicker">{titulo}</span>
      {subtitulo && <span className="tbl-card-title">{subtitulo}</span>}
      {vacio ? (
        <span className="tbl-estado ok">Nada en este corte.</span>
      ) : (
        <div className="tbl-dona">
          <svg viewBox="0 0 100 100" className="tbl-dona-svg" role="img" aria-label={`${titulo}: ${total ?? suma}`}>
            <circle cx="50" cy="50" r={RADIO} fill="none" stroke="#F0F0F0" strokeWidth={GROSOR} />
            {arcos.filter((a) => a.largo > 0).map((a) => (
              <circle
                key={a.s.clave}
                cx="50"
                cy="50"
                r={RADIO}
                fill="none"
                stroke={tono(a.s.tonoxxx).hex}
                strokeWidth={GROSOR}
                strokeDasharray={`${a.largo} ${circunferencia - a.largo}`}
                strokeDashoffset={a.offset}
                transform="rotate(-90 50 50)"
                style={{ cursor: onSegmento ? "pointer" : "default" }}
                onClick={() => onSegmento?.(a.s)}
              >
                <title>{`${a.s.etiqueta}: ${a.s.texto ?? a.s.valor} (${Math.round(a.fraccion * 100)}%)`}</title>
              </circle>
            ))}
            <text x="50" y="48" textAnchor="middle" className="tbl-dona-total">{total ?? suma}</text>
            {totalEtiqueta && <text x="50" y="60" textAnchor="middle" className="tbl-dona-nota">{totalEtiqueta}</text>}
          </svg>
          <div className="tbl-dona-leyenda">
            {arcos.map((a) => (
              <div
                key={a.s.clave}
                className={`tbl-dona-fila ${onSegmento ? "clic" : ""}`}
                onClick={() => onSegmento?.(a.s)}
                title={a.s.nota || (onSegmento ? "Ver en su pantalla" : undefined)}
              >
                <span className="tbl-dona-punto" style={{ background: tono(a.s.tonoxxx).hex }} />
                <span className="tbl-barra-etiqueta">{a.s.etiqueta}</span>
                <span className="tbl-barra-valor">{a.s.texto ?? a.s.valor}</span>
                <span className="tbl-dona-pct">{Math.round(a.fraccion * 100)}%</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Donaxxxx;
